import React from 'react';
import '../../styles/meetleader.css';
import leader from '../../assets/horecaleader.png';
import leader2 from '../../assets/co6-leader.png';



const Chairman = () => {


    return(
    <div className='meetleader'>
        <h4 style={{marginTop:'1.5rem',marginBottom:'1.6rem' , textAlign:'center',color:'#FFD52B',fontSize:'1.2rem'}}>Director Message</h4>
        <hr></hr>
        <div style={{padding:"2rem"}}>
        <h1 style={{textAlign:'center',color:'white',fontSize:'2.6rem',fontWeight:'700'}}>Behind Every Innovation is a Visionary Team</h1>
        
        <div className='meetleader-container' style={{display:'flex', marginTop:'3rem'}}>
            <div className='meetleader-box1 p-3 horecaleader' style={{maxHeight:'400px'}}>
                <img src={leader} width='100%' height='100%' style={{objectFit:'cover',borderRadius:'5px',objectPosition:'top'}}></img>
            </div>
            <div className='meetleader-box2' style={{position:'relative'}}>
            <h6>Tuan Tran Thanh</h6>
            <p style={{fontSize:'0.8rem',color:'#FFD52B'}}>Director’s</p>
            <p style={{color:'white'}}>At Co6 Group, our commitment to excellence drives everything we do. We are dedicated to providing the highest quality food products and services to our clients in the hospitality industry. Our mission is to not only meet but exceed the expectations of our customers, ensuring their success and satisfaction.”</p>
            <h6>Quote</h6>
            <p style={{fontSize:'0.9rem',color:'#FFD52B',fontStyle:'italic'}}>“Our mission is to exceed client expectations, ensuring their success with exceptional products and services”</p>
            
            </div>
        </div>
        <div id='horeca-chairman' className='meetleader-container' style={{display:'flex', marginTop:'3rem'}}>
        <div className='meetleader-box2' style={{position:'relative'}}>
        <h6>Mohamed Jahangir Ghouse</h6>
            <p style={{ fontSize: "0.8rem", color: "#FFD52B" }}>
              Managing Director
            </p>
            <p style={{ color: "white" }}>
              A pioneer in robotics and automation, Jahangir has built CO6 into
              a global leader with a commitment to innovation and quality. His
              vision is to seamlessly integrate robotics into every facet of
              industry and daily life.
            </p>
            <h6>Quote</h6>
            <p
              style={{
                fontSize: "0.9rem",
                color: "#FFD52B",
                fontStyle: "italic",
              }}
            >
              “The future of work is a productive interplay<br></br> between
              humans and robots.”
            </p>
            </div>
            <div className='meetleader-box1 p-3 horecaleader' style={{maxHeight:'400px'}}>
                <img src={leader2} width='100%' height='100%' style={{objectFit:'cover',borderRadius:'5px',objectPosition:'top'}}></img>
            </div>
            
        </div>
        </div>

    </div>);


}

export default Chairman;